import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MonthYear } from '@app/domain/model/monthYear';
import { QueryReportType } from '@app/feature/dealer/query-reports/query-report-type.enum';

@Injectable({
  providedIn: 'root'
})
export class QueryReportsService {

  requestParams: HttpParams;

  queryReportType: string;

  constructor(private readonly http: HttpClient) {
  }

  queryReport(params: any, dealerId?: number) {
    const from: MonthYear = params.queryFrom;
    this.queryReportType = params.queryReportType;

    const to: MonthYear = params.queryTo;


    if (this.isIndustry()) {
      this.requestParams = new HttpParams()
        .set('startInclusive', this.formatDate(from));
    } else {
      this.requestParams = new HttpParams()
        .set('startInclusive', this.formatDate(from))
        .set('endInclusive', this.formatDate(to))
        .set('reportType', params.reportType);
    }
    return this.sendRequestOfType('application/json', 'json', dealerId);
  }

  xls(dealerId?: number) {
    return this.sendRequestOfType('application/vnd.ms-excel', 'blob', dealerId)
      .subscribe(
        response => {
          const fileName = this.queryReportType.toLowerCase() + '-report' + (dealerId ? '-' + dealerId : '') + '.xls';
          if(window.navigator.msSaveOrOpenBlob) { // IE/Edge support (https://stackoverflow.com/questions/24007073/open-links-made-by-createobjecturl-in-ie11)
            const fileData = [response];
            const blobObject = new Blob(fileData);
            window.navigator.msSaveOrOpenBlob(blobObject, fileName);
          } else {
            const anchorElement = document.createElement('a');
            document.body.appendChild(anchorElement);
            const url = window.URL.createObjectURL(response);
            anchorElement.setAttribute('style', 'display: none');
            anchorElement.href = url;
            anchorElement.download = fileName;
            anchorElement.click();
            window.URL.revokeObjectURL(url);
            anchorElement.remove();
          }
        });
  }

  print(dealerId?: number) {
    return this.sendRequestOfType('application/pdf', 'blob', dealerId)
      .subscribe(
        response => {
          const fileName = this.queryReportType.toLowerCase() + '-report' + (dealerId ? '-' + dealerId : '') + '.pdf';
          if(window.navigator.msSaveOrOpenBlob) { // IE/Edge support (https://stackoverflow.com/questions/24007073/open-links-made-by-createobjecturl-in-ie11)
            const fileData = [response];
            const blobObject = new Blob(fileData);
            window.navigator.msSaveOrOpenBlob(blobObject, fileName);
          } else {
            const url = window.URL.createObjectURL(response);
            const anchorElement = document.createElement('a');
            document.body.appendChild(anchorElement);
            anchorElement.setAttribute('style', 'display: none');
            anchorElement.href = url;
            anchorElement.download = fileName;
            anchorElement.click();
            window.URL.revokeObjectURL(url);
            anchorElement.remove();
          }
    });
  }

  sendRequestOfType(contentType: string, myResponseType: any, dealerId?: number) {

    const headers = new HttpHeaders({ 'Accept': contentType });
    const whoseReport = (this.queryReportType !== QueryReportType.industry.value) ? (dealerId ? dealerId : 'mine') + '/' : '';

    const url = 'dealers/' + whoseReport + 'reports/' + this.queryReportType.toLowerCase() + '/';

    return this.http.get(
      url,
      {
        params: this.requestParams,
        headers: headers,
        responseType: myResponseType
      }
    );
  }

  private formatDate(date: MonthYear) {
    const month: number = date.month,
        year: number = date.year;
    return year.toString() + '-' + (month > 9 ? month.toString() : '0' + month.toString());
  }

  isIndustry(): boolean {
    return this.queryReportType === QueryReportType.industry.value;
  }
}
